import React, { Component } from 'react';
import './App.css';
import Playlists from './components/Playlists';
import Particles from 'react-particles-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpotify, faTwitter, faTwitch } from '@fortawesome/free-brands-svg-icons'

const particleOpt = {
    particles: {
        number: {
            value: 25,
            density: {
                enable: false,
                value_area: 0
            }
        },
        color: {
            value: "#ffffff"
        },
        shape: {
            type: "circle",
            stroke: {
                width: 0,
                color: "#000000"
            },
            polygon: {
                nb_sides: 3
            },
            image: {
                src: "img/github.svg",
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 0.5,
            random: false,
            anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.1,
                sync: false
            }
        },
        size: {
            value: 3,
            random: true,
            anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false
            }
        },
        line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 1.9240944730386271
        },
        move: {
            enable: true,
            speed: 6,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200
            }
        }
    },
    interactivity: {
        detect_on: "canvas",
        events: {
            onhover: {
                enable: true,
                mode: "repulse"
            },
            onclick: {
                enable: false,
                mode: "repulse"
            },
            resize: true
        },
        modes: {
            grab: {
                distance: 400,
                line_linked: {
                    opacity: 1
                }
            },
            bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3
            },
            repulse: {
                distance: 200,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            },
            remove: {
                particles_nb: 2
            }
        }
    },
    retina_detect: true
}

class App extends Component {
    render() {
        const spotifyElement = <FontAwesomeIcon className="spotify-icon" icon={faSpotify} onClick={() => window.location = "https://open.spotify.com/user/1qwh2zhtk48r17ymr52liaq0c?si=ecp4k8x2Ss-0mls6606jcg"} />
        const twitterElement = <FontAwesomeIcon className="twitter-icon" icon={faTwitter} onClick={() => window.location = "https://twitter.com/RTZMusicHistory"} />
        const twitchElement = <FontAwesomeIcon className="twitch-icon" icon={faTwitch} onClick={() => window.location = "https://www.twitch.tv/arteezymusichistory"} />

        return (
            <div className="App">
                <header className="App-header">
                    <b><a href="https://twitch.tv/arteezy">Arteezy</a> Music History ♫</b>
                    <div className="App-social"> {spotifyElement} {twitterElement} {twitchElement} </div>
                    <div className="App-info">Refresh and scroll down to the bottom of the latest playlist to see the latest song (if it is avaliable on Spotify)</div>
                    <span className="not-working">Not working? Try opening Spotify and searching for the playlists manually or try use <a href="https://twitchaudio.com/stream/arteezy">https://twitchaudio.com/stream/arteezy</a></span>
                </header>
                <Playlists />
                <footer className="App-footer">
                    <a href="https://info.flagcounter.com/gOGn"><img src="https://s01.flagcounter.com/count2/gOGn/bg_FFFFFF/txt_000000/border_CCCCCC/columns_5/maxflags_25/viewers_0/labels_0/pageviews_1/flags_0/percent_0/" alt="Flag Counter" border="0" /></a>
                    <span>This website is run by a fan and is not officially affiliated with <a href="https://twitter.com/arteezy"> Arteezy</a></span>
                </footer>
                <Particles className="particles-js"
                    params={particleOpt}
                />
            </div>
        );
    }
}

export default App;
